export default [
  {
    path: "/activity",
  },
  {
    path: "/activity/goods_seckill",
    name: "GoodsSeckill",
    meta: {
      title: "限时抢购",
      keepAlive: true,
      backgroundColor: "#ffffff",
    },
    component: () => import("@views/activity/GoodsSeckill.vue"),
  },
  {
    path: "/activity/seckill_detail/:id?/:time",
    name: "SeckillDetails",
    meta: {
      title: "抢购详情页",
      keepAlive: true,
    },
    component: () => import("@views/activity/SeckillDetails.vue"),
  },
  {
    path: "/activity/groupbuy",
    name: "GroupBuyList",
    meta: {
      title: "拼团活动",
      keepAlive: false,
      auth: false,
    },
    component: () => import("@views/groupbuy/Index.vue"),
  },
  {
    path: "/activity/groupbuy/detail/:id",
    name: "GroupBuyDetail",
    meta: {
      title: "拼团详情",
      keepAlive: false,
      auth: false,
    },
    component: () => import("@views/groupbuy/Detail.vue"),
  },
  {
    path: "/spread/activity/:id/0",
    name: "SpreadPurchase",
    meta: {
      title: "团购活动",
      keepAlive: false,
      auth: true,
    },
    component: () => import("@views/purchase/Index.vue"),
  },
  {
    path: "/spread/activity/:id/1",
    name: "SpreadActivity",
    meta: {
      title: "分销活动页",
      keepAlive: false,
      auth: true,
    },
    component: () => import("@views/distribution/Index.vue"),
  },
  {
    path: "/activity/promotion/:id",
    name: "ActivityPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/UserPromotion.vue"),
  },
  {
    path: "/activity/promotion/list/:id",
    name: "ActPromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/PromoterList.vue"),
  },
  {
    path: "/activity/poster/:id",
    name: "ActPoster",
    meta: {
      title: "推广名片",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/Poster.vue"),
  },
  {
    path: "/activity/commission/:id",
    name: "ActCommission",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true,
    },
    component: () =>
      import("@views/distribution/promotion/CommissionDetails.vue"),
  },
  {
    path: "/activity/promoter/order/:id",
    name: "ActPromoterOrder",
    meta: {
      title: "推广人订单",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/PromoterOrder.vue"),
  },
  {
    path: "/activity/promoter/rank/:id",
    name: "ActPromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/PromoterRank.vue"),
  },
  {
    path: "/activity/commission/rank/:id",
    name: "ActCommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true,
    },
    component: () => import("@views/distribution/promotion/CommissionRank.vue"),
  },
];
